export default __webpack_public_path__ + "static/media/education.416b5450.png";